export default {
  // ApiUrl:  'http://localhost/amorel-clasificados/web/app_dev.php/api/v1',
  // ApiRoot: 'http://localhost/amorel-clasificados/web',
  ApiUrl:  'http://www.amorelpasto.com/app_dev.php/api/v1',
  ApiRoot: 'http://www.amorelpasto.com/',
};


// WEBPACK FOOTER //
// ./src/app/services/configuracion/config.ts